import { Layout } from '@/components/layout/Layout';
import { Box, Image, Text } from 'grommet';
import React from 'react';

const NotFound = () => (
  <Layout>
    <Box
      margin={{
        top: `large`,
        bottom: `xlarge`,
      }}
      pad="xlarge"
      background="background-contrast"
      align="center"
      width="max-content"
      alignSelf="center"
      round="small"
    >
      <Image
        src="/img/404.svg"
        width="64px"
        height="64px"
        margin={{ bottom: `large` }}
        alt="error"
      />
      <Text size="xxlarge" weight={700} margin={{ bottom: `medium` }}>
        Error
      </Text>
      <Text size="large" weight={400}>
        Sorry, Page not found.
      </Text>
    </Box>
  </Layout>
);

export default NotFound;
